export default __webpack_public_path__ + "static/media/banner.6c07dfb7.png";